import { MetabaseDashboard } from './MetabaseDashboard'

export const MetabaseCampaignOverview = () => {
  const dashboardId = process.env.REACT_APP_METABASE_CAMPAIGN_DASHBOARD_ID

  if (!dashboardId) {
    // eslint-disable-next-line no-console
    console.error('Dashboard ID is not defined')
    return (
      <div className="flex h-full items-center justify-center p-10">
        <div className="rounded bg-coolGray-50 p-6 text-base-700">
          Unable to load the campaign overview dashboard. Please contact
          support.
        </div>
      </div>
    )
  }

  // You can add additional parameters here when needed
  // For example: additionalParams={{ campaign_id: 'some-id' }}
  return <MetabaseDashboard dashboardId={dashboardId} />
}
